<script setup>
import { __ } from '@/utils';
import { computed, ref } from 'vue';

const currentPaging = ref(0)

const props = defineProps({
    visibleItems : {
        type: Number,
        default: 12
    },
    headings: {
        type: Array,
        default: []
    },
    items: {
        type: Array,
        default: []
    },
    index: {
        type: Number,
        default: []
    },
    footers: {
        type: Array,
        default: []
    },
})

const paginng = computed(() => {
    const pages = Math.ceil(props.items.length / props.visibleItems);

    if(pages > 10) {
        const firstPages = Array(3).fill(0).map((_, index) => index + 1);
        const lastPages = Array(3).fill(0).map((_, index) => pages + index - 2);
        return [...firstPages, '...', ...lastPages];
    }

    return Array(pages).fill(0).map((_, index) => index + 1);
})

// This may be unnecessary if we receive the items via fetch request
const currentItems = computed(() => props.items.slice(props.visibleItems*currentPaging.value, props.visibleItems*(currentPaging.value+1)));
</script>

<template>
    <div class="table table--alt">
        <table> 
            <thead>
                <tr>
                    <th v-for="(heading, index) in headings" :key="index">{{ heading }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in currentItems" :key="item.id">
                    <slot :item="item" :index="index" />
                </tr>
            </tbody>
            <tfoot :class="{'is-grey': currentItems.length % 2 === 0}">
                <tr>
                    <td v-for="(footer, index) in footers" :key="index"><strong>{{ footer }}</strong></td>
                </tr>
            </tfoot>
        </table>
    </div>
    <ul class="table-paging" v-if="paginng.length > 1">
        <li v-for="(page, index) in paginng" :key="index" :class="{'is-active': currentPaging === index}">
            <button @click="currentPaging = index" v-if="page != '...'">{{ page }}</button>
            <span v-else>{{ page }}</span>
        </li>
        <template v-if="currentPaging < paginng.length - 1">
            <li>
                <button @click="currentPaging = currentPaging + 1">{{ __('the next') }}</button>
            </li>
        </template>
    </ul>
</template>